import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { useEffect, useRef } from "react"
import { fetchBonusTransactions, nextPage, selectBonusTransactions, selectBonusTransactionsChecks, selectBonusTransactionsCurrentPage, selectBonusTransactionsFirstLoad, selectBonusTransactionsLoading, selectBonusTransactionsStores } from "../model"
import { PageHeader } from "@/widgets/page-header"
import { PageSubtitle } from "@/shared/ui/page-subtitle"
import { BonusTransactionsTable } from "@/widgets/bonus-transactions-table"

export const BonusTransactionsPage = () => {
    const isFirstRender = useRef(true);
    const page = useAppSelector(selectBonusTransactionsCurrentPage)
    const bonusTransactionsFirstLoad = useAppSelector(selectBonusTransactionsFirstLoad)
    const stores = useAppSelector(selectBonusTransactionsStores)
    const checks = useAppSelector(selectBonusTransactionsChecks)
    const isLoading = useAppSelector(selectBonusTransactionsLoading)
    const transactions = useAppSelector(selectBonusTransactions)
    const dispatch = useAppDispatch()

    useEffect(() => {
        if (!isFirstRender.current) {
            dispatch(fetchBonusTransactions())
        }
    }, [page])

    useEffect(() => {
        if (bonusTransactionsFirstLoad) {
            dispatch(fetchBonusTransactions())
        }
        isFirstRender.current = false
    }, [])

    return (
        <div className="_page_container">
            <PageHeader title="Бонусы" />
            <div className='flexbox'>
                <PageSubtitle variant="acid" title="Транзакции" />
                <BonusTransactionsTable 
                    stores={stores} 
                    checks={checks} 
                    transactions={transactions} 
                    isLoading={isLoading} 
                    nextPage={() => dispatch(nextPage())}                
                />
            </div>
        </div>
    )
}